import { SanityMultilingualString } from "types/graphql-types";

export const computeWorldLocationLabel = (
  region: string | undefined | null,
  country: string | undefined | null
): string => {
  return [region, country].filter((i) => (i ? i.length : false)).join(", ");
};

export type WorldLocationLabelFromPortArgs = Partial<{
  region?: {
    name?: SanityMultilingualString;
    country?: {
      name?: SanityMultilingualString;
    };
  };
  data?: {
    country?: {
      name?: SanityMultilingualString;
    };
  };
}>;

export const worldLocationLabelFromPort = (
  port: WorldLocationLabelFromPortArgs
): string => {
  return computeWorldLocationLabel(
    port?.region?.name?.localized,
    port?.region?.country?.name?.localized ||
      port?.data?.country?.name?.localized
  );
};
